import React from 'react';
import { Link as ScrollLink} from 'react-scroll';
import styled from 'styled-components';

const Data = () => {
  return (
    <SideBlock>
      <div>
        <ScrollLink to="div1" spy={true} smooth={true}>
          <span>Day 1</span>
        </ScrollLink>
        <br />
        <ScrollLink to="div2" spy={true} smooth={true}>
          <span>Day 2</span>
        </ScrollLink>
        <br />
        <ScrollLink to="div3" spy={true} smooth={true}>
          <span>Day 3</span>
        </ScrollLink>
        <br />
        <ScrollLink to="div4" spy={true} smooth={true}>
          <span>Day 4</span>
        </ScrollLink>
      </div>
    </SideBlock>
  );
};

const SideBlock = styled.div`
  width: 10%;
  position: fixed;
  right: 5rem;
  margin-top: 70px;
  div {
    display: flex;
    flex-direction: column;
  }
  span {
    cursor: pointer;
  }
`;

export default Data;
